import faqsTypes from './faqsTypes'

export const getFaqs = () => ({
  type: faqsTypes.GET_FAQS
})

export const getFaqsSuccess = payload => ({
  type: faqsTypes.GET_FAQS_SUCCESS,
  payload
})

export const getFaqsFailure = payload => ({
  type: faqsTypes.GET_FAQS_FAILURE,
  payload
})
